module.exports = __webpack_public_path__ + "static/media/7.74c69b11.jpeg";